export const PORTALS = {
  ACTIVATE_PROMOCODE: "ActivatePromocode",
  ANIMATE_PHOTO: "AnimatePhoto",
  ATTACH_PHOTO_BY_INSTA: "AttachPhotoByInsta",
  ATTACH_PHOTO_BY_URL: "AttachPhotoByUrl",
  BLOCK_USER: "BlockUser",
  BLOG_FEEDBACK: "BlogFeedback",
  BURGER_MENU: "BurgerMenu",
  CAPTCHA: "Captcha",
  CHANGE_LANG: "ChangeLang",
  FEEDBACK: "FeedBack",
  GENERATION_ERROR: "GenerationError",
  GIFT_ROADMAP: "GiftRoadmap",
  NEW_BALANCE: "NewBalance",
  NOTIFICATION_SIDEBAR: "NotificationSidebar",
  PASSKEY: "Passkey",
  PAY_HOLD: "PayHold",
  PWA: "PWA",
  RESET_RE_USE_FACE: "ResetReUseFace",
  RULES: "Rules",
  STORYLINE_RESULT: "StorylineResult",
  SUBSCRIBE_INCLUDED: "SubscribeIncluded",
  SUBSCRIBES_FREE: "SubscribesFREE",
  SUBSCRIBES_VIP: "SubscribesVIP",
  TUTOR_ANIME: "TutorAnime",
  TUTOR_BDSM: "TutorBDSM",
  TUTOR_DRAW: "TutorDraw",
  TUTOR_HD: "TutorHD",
  TUTOR_POSE: "TutorPose",
  TUTOR: "Tutor",
  UPLOAD_VIDEO: "UploadVideo",
};
